import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      {!isHomePage && (
        <section className="bg-brand-blue/5 py-16 border-t border-gray-200">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <img 
              src={process.env.PUBLIC_URL + '/favicon.png'} 
              alt="PocketHints Logo" 
              className="w-16 h-16 mx-auto mb-6 object-contain drop-shadow-sm"
            />
            <h2 className="text-3xl font-black text-gray-900 mb-4">
              Help Us Improve PocketHints
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
              We're always looking for ways to make our hints and guides better for you. Have a suggestion, found a bug, or just want to say hi? We'd love to hear from you!
            </p>
            <a 
              href="https://tally.so/r/BzDVd1" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-brand-blue text-white text-lg font-bold rounded-xl shadow-lg hover:bg-blue-600 hover:scale-105 transition-all duration-200"
            >
              Share Your Feedback
            </a>
          </div>
        </section>
      )}
      <footer className="mt-auto py-12 border-t border-gray-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm font-medium text-gray-600">
          <Link to="/" className="hover:text-brand-blue transition-colors">Home</Link>
          <Link to="/todays-pocket-grids-clues-answers" className="hover:text-brand-blue transition-colors">Pocket Grids</Link>
          <Link to="/todays-syllo-clues-answers" className="hover:text-brand-blue transition-colors">Syllo</Link>
          <Link to="/todays-hot-and-cold-clues-answers" className="hover:text-brand-blue transition-colors">Hot and Cold</Link>
          <Link to="/todays-byrdle-clues-answers" className="hover:text-brand-blue transition-colors">Byrdle</Link>
          <Link to="/daily-guess-solver" className="hover:text-brand-blue transition-colors">DailyGuess Solver</Link>
          <Link to="/archives" className="hover:text-brand-blue transition-colors">Archives</Link>
          <Link to="/search" className="hover:text-brand-blue transition-colors">Search</Link>
          <span className="text-gray-300">|</span>
          <Link to="/about" className="hover:text-brand-blue transition-colors">About Us</Link>
          <Link to="/privacy-policy" className="hover:text-brand-blue transition-colors">Privacy Policy</Link>
          <Link to="/terms-of-service" className="hover:text-brand-blue transition-colors">Terms of Service</Link>
        </div>
        
        <p className="text-gray-400 text-sm italic mb-4">
          © {new Date().getFullYear()} PocketHints Helper
        </p>

        <p className="text-gray-400 text-xs max-w-2xl mx-auto border-t border-gray-100 pt-4">
          Disclaimer: PocketHints is an independent fan-made helper site and is not affiliated with, endorsed by, or sponsored by the creators of any games featured on this site. All game content, images, and trademarks belong to their respective owners.
        </p>
      </div>
    </footer>
    </>
  );
};

export default Footer;

